var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogomark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 408 408",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M203.8,40.79c89.88,0 163,73.12 163,163c0,89.419 -73.581,163 -163,163c-89.88,0 -163,-73.13 -163,-163c0,-89.87 73.13,-163 163,-163m0,-40.79c-112.55,0 -203.8,91.24 -203.8,203.79c0,112.55 91.25,203.79 203.8,203.79c112.55,0 203.8,-91.24 203.79,-203.79c-0.01,-112.55 -91.24,-203.79 -203.79,-203.79Z",
    style: {
      fill: "#00a5b5",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.8,160.61l30.25,30.24c8.02,8.02 12.53,18.908 12.53,30.25c0,23.468 -19.312,42.78 -42.78,42.78c-23.468,0 -42.78,-19.312 -42.78,-42.78c0,-11.342 4.51,-22.23 12.53,-30.25l30.25,-30.24m0,-57.67l-59.09,59.07c-15.662,15.664 -24.47,36.931 -24.47,59.082c0,45.839 37.72,83.56 83.56,83.56c45.84,0 83.56,-37.721 83.56,-83.56c0,-22.151 -8.808,-43.418 -24.47,-59.082l-59.09,-59.07Z",
    style: {
      fill: "#00a5b5",
      fillRule: "nonzero"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/logomark.d775c96c5a8ebf6fb86501febc06f4e6.svg";
export { ForwardRef as ReactComponent };